import React from 'react';
import PropTypes from 'prop-types';

// Components
import { DataTable } from '@cashfree-intl/coherent';
import CustomIcons from 'components/CustomIcons';
import styled from 'styled-components';

export const DataTableWrapper = styled.div`
  .checkbox {
    min-height: 18px !important;
  }
`;

const PaginatedTable = ({
  data,
  limit,
  hasPrev,
  hasNext,
  totalCount,
  currentPage,
  onPageChange,
  onLimitChange,
  tableHeading,
  emptyTableComponent,
  fetching = false,
  onRowClick,
  isPaginated = true,
  limitOptions,
  currentPageCount,
  withSelect,
  rowExpansion,
}) => {
  const paginationInfo = {
    limit,
    limitOptions,
    hasPrev,
    hasNext,
    onPageChange,
    currentPageCount,
    onLimitChange,
    startRecordCount: currentPage * limit - limit + 1,
    endRecordCount: totalCount
      ? Math.min(currentPage * limit, totalCount)
      : currentPage * limit,
  };

  const noRecordsObj = {
    icon: <CustomIcons componentName="BOX" />,
    text: 'No result found',
  };

  return (
    <DataTableWrapper>
      <DataTable
        columns={tableHeading}
        rowSelect={withSelect}
        records={data}
        {...(isPaginated ? { pagination: paginationInfo } : {})}
        noRecords={emptyTableComponent || noRecordsObj}
        fetching={fetching}
        {...rowExpansion && {
          rowExpansion: row => rowExpansion(row),
        }}
        {...onRowClick && { onRowClick: row => onRowClick(row.original) }}
      />
    </DataTableWrapper>
  );
};
const NoRecordProps = PropTypes.shape({
  text: PropTypes.string,
  icon: PropTypes.node,
  description: PropTypes.string || PropTypes.node,
  action: PropTypes.node,
});

PaginatedTable.propTypes = {
  data: PropTypes.array.isRequired,
  limit: PropTypes.number.isRequired,
  hasPrev: PropTypes.bool.isRequired,
  hasNext: PropTypes.bool.isRequired,
  totalCount: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onLimitChange: PropTypes.func.isRequired,
  tableHeading: PropTypes.any.isRequired,
  emptyTableComponent: NoRecordProps,
  fetching: PropTypes.bool,
  onRowClick: PropTypes.func,
  rowExpansion: PropTypes.func,
  isPaginated: PropTypes.bool,
  limitOptions: PropTypes.array,
  currentPageCount: PropTypes.number,
  withSelect: PropTypes.any,
};

export default PaginatedTable;
